// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProgressBar_wrapper__vcyrC","progress":"ProgressBar_progress__4yQmX"};